import { defineMessages } from 'react-intl';

export default defineMessages({
  skuHeader: {
    description: 'Header for SKU column in CSV export',
    defaultMessage: 'SKU',
    id: '73pHF5',
  },
  productNameHeader: {
    description: 'Header for Product Name column in CSV export',
    defaultMessage: 'Product Name',
    id: 'iDrKKv',
  },
  currentOnHandHeader: {
    description: 'Header for Current On Hand column in CSV export',
    defaultMessage: 'Current On Hand',
    id: '8FfqVA',
  },
  reorderThresholdHeader: {
    description: 'Header for Reorder Threshold column in CSV export',
    defaultMessage: 'Reorder Threshold',
    id: 'k+3Gqu',
  },
  avgOrdersHeader: {
    description: 'Header for Avg Orders column in CSV export',
    defaultMessage: 'Avg Orders',
    id: '4tyEFC',
  },
  suggestedReorderHeader: {
    description: 'Header for Suggested Reorder column in CSV export',
    defaultMessage: 'Suggested Reorder',
    id: 'CAz5XR',
  },
  quantityHeader: {
    description: 'Header for Quantity column in CSV export',
    defaultMessage: 'Quantity',
    id: '9gQ9pZ',
  },
  warehouseIdHeader: {
    description: 'Header for Warehouse ID column in CSV export',
    defaultMessage: 'Warehouse ID',
    id: 'WcNhFu',
  },
  warehouseLocationHeader: {
    description: 'Header for Warehouse Location column in CSV export',
    defaultMessage: 'Warehouse Location',
    id: 'XbOxGW',
  },
  warehouse1Header: {
    description: 'Header for Warehouse 1 column in CSV export',
    defaultMessage: 'Warehouse 1',
    id: 'd250Ra',
  },
  warehouse2Header: {
    description: 'Header for Warehouse 2 column in CSV export',
    defaultMessage: 'Warehouse 2',
    id: 'zhDj+t',
  },
  warehouse3Header: {
    description: 'Header for Warehouse 3 column in CSV export',
    defaultMessage: 'Warehouse 3',
    id: 'HoO2PV',
  },
  totalHeader: {
    description: 'Header for Total column in CSV export',
    defaultMessage: 'Total',
    id: 'xgjuIV',
  },
  availableHeader: {
    description: 'Header for Available column in CSV export',
    defaultMessage: 'Available',
    id: '8IPoj9',
  },
  allocatedHeader: {
    description: 'Header for Allocated column in CSV export',
    defaultMessage: 'Allocated',
    id: 'IZxNUz',
  },
  productTypeHeader: {
    description: 'Header for Product Type column in CSV export',
    defaultMessage: 'Product Type',
    id: 'I45v7L',
  },
  totalAvailableAllWarehousesHeader: {
    description: 'Header for Total Available (All Warehouses) column in CSV export',
    defaultMessage: 'Total Available (All Warehouses)',
    id: '3KkAWA',
  },
  csvDownloadError: {
    description: 'Error message when CSV download fails',
    defaultMessage: 'Failed to download CSV file',
    id: 'YNYBe+',
  },
});
